import { useState, useEffect } from 'react';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturedCampaigns from './components/FeaturedCampaigns';
import HowItWorks from './components/HowItWorks';
import CategorySection from './components/CategorySection';
import TrustSection from './components/TrustSection';
import CtaSection from './components/CtaSection';
import IdeaModal from '@/components/feature/IdeaModal';

const HomePage = () => {
  const [modalOpen, setModalOpen] = useState(false);

  // Lock body scroll when modal is open
  useEffect(() => {
    if (modalOpen) {
      const scrollY = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = '100%';
      document.body.style.overflowY = 'scroll';
    } else {
      const scrollY = document.body.style.top;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      document.body.style.overflowY = '';
      if (scrollY) {
        window.scrollTo(0, parseInt(scrollY || '0') * -1);
      }
    }
    return () => {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      document.body.style.overflowY = '';
    };
  }, [modalOpen]);

  return (
    <div className="min-h-screen bg-white" dir="rtl">
      <IdeaModal forceOpen={modalOpen} onClose={() => setModalOpen(false)} />
      <HeroSection />
      <FeaturedCampaigns />
      <HowItWorks />
      <CategorySection />
      <TrustSection />
      <CtaSection />
      <Footer />

      {/* Floating button to reopen modal */}
      <button
        onClick={() => setModalOpen(true)}
        title="عرض فكرة المنصة"
        className="fixed bottom-6 left-6 z-40 flex items-center gap-2 px-4 py-2.5 rounded-full text-white text-xs font-semibold active:scale-95 transition-all duration-200 cursor-pointer whitespace-nowrap"
        style={{
          fontFamily: "'Noto Naskh Arabic', serif",
          background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 50%, #b45309 100%)',
          boxShadow: '0 4px 18px rgba(217,119,6,0.45)',
        }}
      >
        <div className="w-4 h-4 flex items-center justify-center">
          <i className="ri-lightbulb-flash-line text-sm"></i>
        </div>
        عرض فكرة المنصة
      </button>
    </div>
  );
};

export default HomePage;
